resourcePaths = '{"rootPath":"","assetsPath":""}';/*
Helpers
  General helper methods to use throughout the codebase
*/

var GeneralHelpers = {

  /*
    Checks whether a value is a number

    Arguments:
    data (required):
      The data to check

    Returns:
      Bool: input is type Number
    */
  isNum: function(data) {
    return !isNaN(data);
  }
};
